#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

mutation PayCycleAccountingUnstamper(
  $input: PayCycleAccountingUnstamperInput!
) {
  payCycleAccountingUnstamper(input: $input) {
    payCycle {
      id
      _documentPackageId
      _rowTimestamp
      _isHistory
      _isUpdatable
      _isApprovalRevocable
      _isAccountingEntry
      _accountingStampDate
      _accountingStampTransactionReference
      _accountingStampUserName
      _isAccountingEntryStampedComplete
      _isTransactionCancelled
      _emailDocument {
      ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
    }
  }
}
